declare global {
  interface Window {
    MSStream: string;
  }
}
export const useMobileOperatingSystem = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /(android)/i.test(navigator.userAgent);

  return {
    isMobileOperatingSystem: isIOS || isAndroid,
  };
};
